import { Relation } from './relation.model';
import { BaseModel } from '@tcc-mono/shared/data-access';

export class User extends BaseModel {
  id: string;
  name: string;
  username: string;
  email: string;
  email_verified_at?: string;
  created_at?: string;
  updated_at?: string;
  relation?: Relation;
  relation_id?: number;
  role: 'trader' | 'admin' | 'farmer';
  two_factor_enabled: boolean;

  public constructor(
    user?: Partial<User>
  ) {
    super();

    this.id = user?.id;
    this.name = user?.name;
    this.username = user?.username;
    this.email = user?.email;
    this.email_verified_at = user?.email_verified_at;
    this.created_at = user?.created_at;
    this.updated_at = user?.updated_at;
    this.relation = user?.relation;
    this.relation_id = user?.relation_id || user?.relation?.id;
    this.role = user?.role || 'admin';
    this.two_factor_enabled = user?.two_factor_enabled ?? false;
  }
}
